<template>
  <footer class="site-footer">
    <div class="footer-links">
      <router-link to="/about">{{ $t("footer.about") }}</router-link>
      <router-link to="/research">{{ $t("footer.research") }}</router-link>
      <router-link to="/contact">{{ $t("footer.contact") }}</router-link>
    </div>
    <p>{{ $t("footer.copyright") }}</p>
    <p>
      {{ $t("footer.addressInfo") }}
      <a href="https://beian.miit.gov.cn/">粤ICP备2025511930号</a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.site-footer {
  background: #003366;
  color: #fff;
  text-align: center;
  padding: 20px;
  margin-top: 50px;
}
.footer-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.footer-links a {
  color: #fff;
  margin: 5px 10px;
  text-decoration: none;
}
.footer-links a:hover {
  text-decoration: underline;
}
</style>
